/** O2O 排班时段工具：自定义 HH:mm-HH:mm */

export const DEFAULT_PROVIDER_SLOTS = [
  '08:00-10:00',
  '10:00-12:00',
  '13:00-15:00',
  '15:00-17:00',
  '17:00-19:00'
]

export const DEFAULT_STORE_SLOTS = [
  '09:00-10:00',
  '10:00-11:00',
  '11:00-12:00',
  '14:00-15:00',
  '15:00-16:00',
  '16:00-17:00'
]

const SLOT_RE = /^([01]\d|2[0-3]):([0-5]\d)-([01]\d|2[0-3]):([0-5]\d)$/

export function parseSlot(slot: string): { start: string; end: string } | null {
  const m = String(slot || '').trim().match(SLOT_RE)
  if (!m) return null
  return { start: `${m[1]}:${m[2]}`, end: `${m[3]}:${m[4]}` }
}

export function toMinutes(hm: string): number {
  const [h, m] = hm.split(':').map(Number)
  return h * 60 + m
}

export function formatSlot(start: string, end: string): string {
  return `${start}-${end}`
}

/** 返回错误文案；合法则返回 null */
export function validateSlotRange(start?: string, end?: string): string | null {
  if (!start || !end) return '请选择开始和结束时间'
  if (!/^\d{2}:\d{2}$/.test(start) || !/^\d{2}:\d{2}$/.test(end)) {
    return '时间格式须为 HH:mm'
  }
  if (toMinutes(start) >= toMinutes(end)) {
    return '结束时间须晚于开始时间'
  }
  return null
}

export function sortSlots(slots: string[]): string[] {
  return [...new Set(slots.filter(Boolean))].sort((a, b) => {
    const pa = parseSlot(a)
    const pb = parseSlot(b)
    if (!pa && !pb) return a.localeCompare(b)
    if (!pa) return 1
    if (!pb) return -1
    return toMinutes(pa.start) - toMinutes(pb.start)
  })
}

/**
 * 把接口返回的日期统一成 YYYY-MM-DD。
 * 兼容：字符串、带时间、时间戳、Jackson 数组 [y,m,d]。
 */
export function normalizeWorkDate(raw: unknown): string {
  if (raw == null || raw === '') return ''
  if (Array.isArray(raw) && raw.length >= 3) {
    const y = Number(raw[0])
    const m = Number(raw[1])
    const d = Number(raw[2])
    if (y > 0 && m > 0 && d > 0) {
      return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
    }
  }
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const dt = new Date(raw)
    if (!Number.isNaN(dt.getTime())) {
      const y = dt.getFullYear()
      const m = String(dt.getMonth() + 1).padStart(2, '0')
      const d = String(dt.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  }
  const s = String(raw).trim()
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/)
  if (m) return m[1]
  return s
}

export function slotKey(workDate: string | unknown, timeSlot: string): string {
  return `${normalizeWorkDate(workDate)}|${String(timeSlot || '').trim()}`
}

/** 同日时段是否重叠（半开区间 [start,end)） */
export function slotsOverlap(a: string, b: string): boolean {
  const pa = parseSlot(a)
  const pb = parseSlot(b)
  if (!pa || !pb) return false
  const a0 = toMinutes(pa.start)
  const a1 = toMinutes(pa.end)
  const b0 = toMinutes(pb.start)
  const b1 = toMinutes(pb.end)
  return a0 < b1 && b0 < a1
}
